import React from "react";
import PropTypes from "prop-types";
// import { MDCTextField } from "@material/textfield";

import axios from "axios";
import countries from "../utils/country-list";

const ID = 1144;

import { PageContext } from "../context/page-context";
class AskQuestion extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      form: {
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        question: "",
        newsletter: 0,
        mode: "AskAQuestion",
        LatestMainSource: "Contact Request",
        LatestSubSource: props.block.content.sub_source,
      },
      submitLabel: "Send message",
      isDisabled: false,
      formSubmitted: false,
    };

    this.fields = [];

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.submitForm = this.submitForm.bind(this);
  }

  componentDidMount() {
    setTimeout(() => {
      const { MktoForms2 } = window;
      if (typeof MktoForms2 !== 'undefined') {
        MktoForms2.loadForm("//go.gettimely.com", "304-RPU-875", ID, (form) => {
        });
      }
    }, 100);
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;
    const { form } = this.state;

    const newForm = Object.assign({}, form, { [name]: value });

    this.setState({
      form: newForm,
    });
  }

  handleSubmit(event) {
    event.preventDefault();
    const { form } = this.state;

    let geolocation = "GB";
    if (this.context) {
      geolocation = this.context.geolocation;
    }

    let country = "Unknown";

    if (geolocation) {
      country = countries[geolocation];
    }

    const { AutopilotAnywhere } = window;
    if (AutopilotAnywhere && AutopilotAnywhere.sessionId) {
      form.autopilotSessionId = AutopilotAnywhere.sessionId;
    }

    form.country = country;
    form.source = window.location.pathname || "";
    form.privacy = true;

    // Ensure our form doesnt submit without a name and email
    if (form.firstName.length > 0 && form.email.length > 0) {
      this.submitForm(form);
    }
  }

  submitForm(form) {
    form.LatestMainSource = "Contact Request";
    axios.post("/st/fennel", form);

    this.setState({
      formSubmitted: true,
    });
  }

  renderTextField(label, id) {
    const { isDisabled } = this.state;

    return (
      <div>
        <div className='mdc-text-field mdc-text-field--fullWidth mdc-text-field--outlined'>
          <input
            className='mdc-text-field__input'
            data-testid={id}
            disabled={isDisabled}
            name={id}
            onChange={this.handleInputChange}
            required={true}
          />
          <div className='mdc-notched-outline'>
            <div className='mdc-notched-outline__leading'></div>
            <div className='mdc-notched-outline__notch'>
              <label className='mdc-floating-label'>{label}</label>
            </div>
            <div className='mdc-notched-outline__trailing'></div>
          </div>
        </div>
        <div className='mdc-text-field-helper-line'>
          <p className='mdc-text-field-helper-text mdc-text-field-helper-text--validation-msg'>
            This field is required
          </p>
        </div>
      </div>
    );
  }

  render() {
    const { config, content } = this.props.block;

    // const { isDisabled, submitLabel, formSubmitted } = this.state;
    const { formSubmitted } = this.state;

    const classNames =
      config && config.className
        ? `AskQuestion ${config.className}`
        : "AskQuestion u-vSpacingLG-top ";

    const style = content["background-image"]
      ? {
        backgroundImage: `url(${content["background-image"]})`,
      }
      : {};

    return (
      <div className={classNames}>
        <div
          id='ask-question'
          name='ask-question'
          className='AskQuestion-background'
          style={style}
        >
          <div className='container u-vSpacingMD AskQuestion-container'>
            <div className='row u-textCenter'>
              <div className='col-md-offset-3 col-md-6 col-xl-offset-4 col-xl-4'>
                {formSubmitted && (
                  <div className='AskQuestion-card'>
                    <div className='col-xs-12'>
                      <h2 className='AskQuestion-title'>Thanks,</h2>
                      <p>Someone from our friendly team will be in touch.</p>
                      <p>
                        While you’re here, why not{" "}
                        <a
                          href='https://app.gettimely.com/register'
                          className='start-a-trial-link'
                        >
                          give Timely a try?
                        </a>
                      </p>
                    </div>
                  </div>
                )}
                {!formSubmitted && (
                  <div className='AskQuestion-card form-labels-dark'>
                    <div className='col-xs-12'>
                      <h2 className='AskQuestion-title'>{content.title}</h2>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: content.description,
                        }}
                      />
                      <form id={`mktoForm_${ID}`}></form>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

AskQuestion.propTypes = {
  block: PropTypes.shape({
    config: PropTypes.shape({
      className: PropTypes.string,
    }),
    content: PropTypes.shape({}),
  }),
};

AskQuestion.contextType = PageContext;

export default AskQuestion;
